module.exports = __webpack_public_path__ + "static/img/pic24.1.4672673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic24.1.png
// module id = b9zp
// module chunks = 0